import { bb } from "$json";
/* gauge.js
 *
 * This plugin is meant to add gauge-like images
 * to any node which has a text interface with
 * the class 'bbm-gauge'.
 *
 * The interface should hold the file name
 * of the gauge image required.
 *
 * Author: Tim Bauwens
 * Copyright (C) by Berkeley Bridge 2018
 */

(function (doc, $) {
  $(doc).on("bb:postHandleData", function (e, data) {
    if (data && data.groups) {
      var $gauge = $(".bbm-gauge");
      $gauge.css({
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        minHeight: "200px",
        opacity: "0"
      });
      if ($gauge.length > 0) {
        $gauge.each(function (i, el) {
          var file = $(el).html(),
            alias = bb.conf.theme,
            img_url =
              "custom/" +
              alias +
              "/plugins/gauge/live/" +
              file +
              "?v20190117-1",
            img_alt = file.replace(/-/gi, " ").slice(0, -4),
            $img = $(
              '<div class="p-gauge no-load"><p>' + img_alt + "</p></div>"
            );

          // Fallback:
          $(el).html($img);
          setTimeout(function () {
            $gauge.animate({ opacity: 1 }, 200);
          }, 500);

          // Try for image replace:
          $.get(img_url).done(function () {
            $img = $(
              '<div class="p-gauge">' +
                "<img " +
                'src="' +
                img_url +
                '" ' +
                'alt="' +
                img_alt +
                '" />' +
                "</div>"
            );

            $(el).css({ opacity: 0 }).html($img).animate({ opacity: 1 }, 200);
          });
        });
      }
    }
  });
})(document, jQuery);
